import {Grid, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import * as classes from './Header.classes'

type Props = React.PropsWithChildren<{
  lead: React.ReactNode
  tail?: React.ReactNode
  className?: string
}>

export function Header({children, lead, tail, className}: Props): React.ReactElement {
  return (
    <Grid alignItems="center" className={clsx(classes.root, className)} wrap="nowrap" container>
      <Grid className={classes.lead} item>
        {lead}
      </Grid>
      <Typography Component={Grid} group="tight" thickness="medium" variant="title4" item>
        {children}
      </Typography>
      {tail && (
        <Grid className={classes.tail} item>
          {tail}
        </Grid>
      )}
    </Grid>
  )
}
